<template>
  <div id="app" v-show="loading">
    <router-view />
    <div id="right_fixed" v-if="$store.state.screenWidth > 960">
      <div class="_top"></div>
      <div class="_btm"></div>
      <div id="to_top" @click="backTop" v-show="scroll > 200">
        <i class="el-icon-top"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scroll: 0,
      routeName: "",
      screenWidth: document.body.clientWidth,
      timer: false,
      loading: false,
    };
  },
  // 滚动监听
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
    this.$store.state.screenWidth = document.body.clientWidth;
    this.init();
    const that = this;
    window.onresize = () =>
      (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
  },
  watch: {
    screenWidth(val) {
      const that = this;
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.$store.state.screenWidth = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          console.log(that.$store.state.screenWidth, "this.screenWidth");
          that.init();
          that.timer = false;
        }, 10);
      }
    },
  },
  methods: {
    init() {
      // this.loading = true;
      this.routeName = this.$route.name;
      if (this.routeName === "Index") {
        this.$store.commit("changeHeadNav", this.routeName);
      }
      // setInterval(() => {
      setTimeout(() => {
        let docEl = document.documentElement,
          clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        if (this.screenWidth > 960) {
          docEl.style.fontSize = 100 * (clientWidth / 1920) + "px";
        } else {
          docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
        }
        if (document.readyState === "complete") {
          this.loading = true;
        }
        setTimeout(() => {
          this.loading = true;
        }, 500);
        // docEl.style.fontSize = 100 * (clientWidth / 1920) + "px";
      }, 1000);
    },
    // 获取页面滚动距离
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop, "滚动距离");
      this.scroll = scrollTop;
    },
    backTop() {
      // var timer = setInterval(function () {
      // let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let osTop = 0;
      //   let ispeed = Math.floor(-osTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop = osTop;
      //   this.isTop = true;
      //   if (osTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 30);
    },
  },
  // 滚动重置
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  // border: 1px solid #f0f;
}
h1 {
  margin: 0;
  padding: 0;
}
html,
body {
  scroll-behavior: smooth;
}
#app {
  position: relative;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  pre {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    white-space: pre-wrap;       /* css-3 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
    overflow: auto;
    word-break: break-all;
    word-wrap: break-word;
  }
  #to_top {
    cursor: pointer;
    // position: fixed;
    // right: 1.2rem;
    // bottom: 1rem;
    margin-top: 0.2rem;
    width: 0.6rem !important;
    height: 0.6rem !important;
    line-height: 0.25rem;
    text-align: center;
    background-color: #fff;
    box-shadow: 0rem 0.06rem 0.106rem 0.014rem rgba(113, 113, 113, 0.11);
    z-index: 99999;
    transition: all 0.5s ease-in-out;
    border-radius: 0.08rem;
    // vertical-align: top;
    i {
      font-size: 0.4rem;
      color: #9f9f9f;
    }
    &:hover {
      background: #3660aa;
    }
    &:hover i {
      color: #fff;
    }
  }
  #right_fixed {
    min-height: 3rem;
    width: 0.9rem;
    // height: 235px;
    position: fixed;
    right: 1.05rem;
    top: 70%;
    transform: translateY(-50%);
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      width: 0.8rem;
      height: 0.8rem;
    }
    ._top {
      position: relative;
      background: url("./assets/images/right_code1.png") no-repeat;
      background-position: center;
      background-size: cover;
      margin-bottom: 0.4rem;
      &::before {
        content: "微信公众号";
        position: absolute;
        top: -0.18rem;
        left: 0;
        font-size: 0.14rem;
        color: #b2c6df;
        display: block;
        width: 0.83rem;
      }
      // &:hover {
      //   width: 180px;
      //   height: 180px;
      // }
    }
    ._btm {
      position: relative;
      background: url("./assets/images/right_code2.png") no-repeat;
      background-position: center;
      background-size: cover;
      &::before {
        content: "微信视频号";
        position: absolute;
        top: -0.18rem;
        left: 0;
        font-size: 0.14rem;
        color: #b2c6df;
        display: block;
        width: 0.83rem;
      }
    }
  }
}
// 版心
._center {
  width: 14.03rem;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue